import { OrderConstants } from '../constants/order.constants';
import { OfflineOrderState } from '../modules/offline-ipo/models/offline-ipo.model';
import { OMSOrder } from '../modules/order';
import {
	EasyState,
	EasyValidityTypeCode,
	From,
	IOrder,
	OmsOrderStates,
	Side
} from '../modules/order/oms/models/orderModels.model';

export const isInErrorState = (order: IOrder): boolean => {
	// نکته اول: علت اینکه دیلیت بای ان اس سی به دو صورت نوشته شد، تفاوت آن بین او‌ام‌اس و ال‌اس است
	return (
		order?.orderState === OmsOrderStates.Error /* || omsOrderState === OmsOrderStates.DeleteByNSC*/ ||
		order?.orderState === OmsOrderStates.DeleteByNsc
	);
};
export const executedQuantity = (order: IOrder): number => {
	let executed = 0;
	order.trades?.forEach(trade => {
		if (!trade.isCancel) executed += trade.quantity;
	});
	return executed;
};

export const isDone = (order: IOrder): boolean => {
	if (!order) return null;
	const omsOrderState = +order.orderState;

	return (
		omsOrderState === OmsOrderStates.OrderExecuted ||
		omsOrderState === OmsOrderStates.PartiallyExecutedAndExpired ||
		omsOrderState === OmsOrderStates.PartiallyExecutedAndCanceled ||
		omsOrderState === OmsOrderStates.PartiallyExecutedAndError ||
		(executedQuantity(order) > 0 &&
			(omsOrderState === OmsOrderStates.Cancel ||
				omsOrderState === OmsOrderStates.Modify ||
				omsOrderState === OmsOrderStates.PartiallyExecutedAndModified))
	);
};
export const isOfflineError = (order: IOrder): boolean => {
	if (!order) return false;
	return order.isOffline && order.state === OfflineOrderState.Error;
};
export const isWaiting = (order: IOrder): boolean => {
	if (!order) return false;
	return true;
	// return order.easyState === EasyState.InProgress || order.easyState === EasyState.Done;
};
export const isSelectable = (order: IOrder): boolean => {
	if (order && order.isOffline) return false;
	if (order && order.isDraft) return true;
	// if (!order?.id?.startsWith(OrderConstants.MofidOrderIdStartString)) return false;
	return !isDone(order);
};
export const isDraft = (order: IOrder): boolean => {
	if (!order) return null;
	return order.isDraft;
};
export const isBuy = (order: IOrder): boolean => {
	if (!order) return null;
	return order.side.toString() === 'Buy' || order.side === Side.Buy;
};
export const isSell = (order: IOrder): boolean => {
	if (!order) return null;
	return order.side.toString() === 'Sell' || order.side === Side.Sell;
};

export const filterInvisibleStates = (order: OMSOrder): boolean => {
	const omsOrderState = order.orderState;
	if (
		order.easyState === EasyState.EditMode ||
		((omsOrderState === OmsOrderStates.Cancel ||
			omsOrderState === OmsOrderStates.Modify ||
			(omsOrderState === OmsOrderStates.CancelByBroker && order.orderFrom !== From.System)) &&
			(!order?.ExecutedQuantity || order?.ExecutedQuantity === 0))
	)
		return false;

	if (order.parentId && order.IsInErrorState) return false;
	// if (order.easyState === EasyState.EditMode) return false;

	return true;
};

export const isOrderShowable = (
	order: IOrder,
	showRed: boolean,
	showGreen: boolean,
	showDraft: boolean,
	showDone: boolean
): boolean => {
	if (!order) return false;
	// hiding deleted orders (omsOrderState = 'Cancel')
	const omsOrderState = +order.orderState;
	if (
		(omsOrderState === OmsOrderStates.Cancel ||
			(omsOrderState === OmsOrderStates.CancelByBroker && order.orderFrom !== From.System)) &&
		(!executedQuantity(order) || executedQuantity(order) === 0)
	)
		return false;

	if (order.parentId && isInErrorState(order)) return false;
	if (
		(order.isParentOfOnModifyBoard || omsOrderState === OmsOrderStates.Modify) &&
		(!executedQuantity(order) || executedQuantity(order) === 0)
	)
		return false;

	const isBuyOrder = isBuy(order);
	const isSellOrder = isSell(order);
	const isDoneOrder = isDone(order);

	// handling 'Done' orders
	if (showDone && isDoneOrder) {
		if (showGreen && isBuyOrder) return true;
		if (showRed && isSellOrder) return true;
		if (!showRed && !showGreen) return true;
		return false;
	}
	if (isDoneOrder) return false;

	// handling 'Draft' orders
	const isDraftOrder = isDraft(order);
	if (showDraft && isDraftOrder) {
		if (showGreen && isBuyOrder) return true;
		if (showRed && isSellOrder) return true;
		if (!showRed && !showGreen) return true;
		return false;
	}
	if (isDraftOrder) return false;

	if (showGreen && isBuyOrder) return true;
	if (showRed && isSellOrder) return true;
	return false;
};

export const isValidForOrderPlaceSub = (order: IOrder): boolean => {
	const omsOrderState = +order?.orderState;
	return (
		omsOrderState === OmsOrderStates.OnBoard ||
		omsOrderState === OmsOrderStates.PartiallyExecution ||
		omsOrderState === OmsOrderStates.OnModifyBoard ||
		omsOrderState === OmsOrderStates.OnCancelError ||
		omsOrderState === OmsOrderStates.OnModifyError ||
		omsOrderState === OmsOrderStates.SentToNsc
	);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isSupervisorOrder = (orderId: string): boolean => {
	// if (orderId?.length > 0 && !orderId?.startsWith(OrderConstants.MofidOrderIdStartString)) return true;
	return false;
};
export const isDeleteValid = (order: IOrder): boolean => {
	if (!order) return null;
	if (order.isDraft) return true;
	const orderMessage = order.responseErrorMessage;
	if (
		isSupervisorOrder(order.id) ||
		isDone(order) ||
		isWaiting(order) ||
		+order.orderState === OmsOrderStates.DeleteBySupervisor ||
		+order.orderState === OmsOrderStates.CancelBySurveillance ||
		+order.orderState === OmsOrderStates.Expired ||
		+order.orderState === OmsOrderStates.CancelByBroker ||
		+order.orderState === OmsOrderStates.OnSending ||
		// (order.omsIsSuccessful || +order.orderState === OmsOrderStates.Modify) ||
		orderMessage === OrderConstants.Messages.OrderInDeleteQueue ||
		orderMessage === OrderConstants.Messages.OrderInDeleteQueue ||
		orderMessage === OrderConstants.Messages.DraftInDeleteQueue ||
		orderMessage === OrderConstants.Messages.OrderInModifyQueue ||
		orderMessage === OrderConstants.Messages.DraftInModifyQueue ||
		orderMessage === OrderConstants.Messages.OrderDeletedSuccessfully ||
		orderMessage === OrderConstants.Messages.DraftDeletedSuccessfully
	)
		return false;
	return true;
};

export const isEditValid = (order: IOrder): boolean => isDeleteValid(order) && !isInErrorState(order);
export const isSendAndCopyValid = (order: IOrder): boolean => {
	const orderMessage = order.responseErrorMessage;
	return (
		order && order.easyState === EasyState.Done && orderMessage !== OrderConstants.Messages.DraftDeletedSuccessfully
	);
};

export const isOrderPartiallyExecuted = (order: IOrder): boolean => {
	const states = [
		OmsOrderStates.PartiallyExecutedAndCanceled,
		OmsOrderStates.PartiallyExecutedAndError,
		OmsOrderStates.PartiallyExecutedAndExpired,
		OmsOrderStates.PartiallyExecutedAndModified
	];
	return states.includes(+order.orderState);
};

export const isOrderValidToDate = (order: IOrder): boolean =>
	order.validityType === EasyValidityTypeCode.ValidToDate ||
	order.validityType === EasyValidityTypeCode.Month ||
	order.validityType === EasyValidityTypeCode.Week ||
	order.validityType === EasyValidityTypeCode.ValidToCancellation;
